


























































import {
    SdsDividerLine,
    SdsFlag,
    SdsIcon,
} from '@superbet-group/web.lib.ui-components';
import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';
import {
    defineComponent,
    computed,
    PropType,
} from '@vue/composition-api';

import { RouteName } from '@app/router/constants/RouteName';
import { slugify } from '@app/utils/slugify';
import { CategoryWithCompetitions } from '@core/models/struct/CategoryWithCompetitions';
import {
    sportUrlName as getSportUrlName,
    categoryUrlName as getCategoryUrlName,
    tournamentUrlName as getTournamentUrlName,
} from '@modules/eventGrid/nameExtractors';
import { getFlagByCategory } from '@sportOfferFederation/flags/flagMapping';
import { simplifyTournamentName } from '@core/utils/sportsOffer/simplifyTournamentName';
import { getShellConfig } from '@src/config/shell/config';
import { ExpandedEventInUrl } from '@src/app/enums';
import { TimeFilterSlug } from '@store/modules/ui/shared/timeFilter/utils';

export default defineComponent({
    name: 'SportCompetitionCard',
    props: {
        categoryWithCompetitions: {
            type: Object as PropType<CategoryWithCompetitions>,
            required: true,
        },
        isExpanded: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['update:isExpanded'],
    setup(props, { emit }) {
        const {
            pushRoute,
            router,
        } = useVueRouter();

        function toggleIsExpanded() {
            emit('update:isExpanded', !props.isExpanded);
        }

        function getTournamentRoute(tournamentId: number) {
            const categoryName = getCategoryUrlName(props.categoryWithCompetitions.categoryId);
            const sportSlug = slugify(getSportUrlName(props.categoryWithCompetitions.sportId));
            const categorySlug = slugify(categoryName);
            const originalTournamentName = getTournamentUrlName(tournamentId);
            const tournamentSlug = slugify(
                simplifyTournamentName(
                    originalTournamentName,
                    categoryName,
                ),
            );

            const params = {
                sportSlug,
                categorySlug,
                tournamentSlug,
                timeFilter: TimeFilterSlug.All,
            };

            return router.value.resolve({
                name: RouteName.Sport.Competition,
                params,
                query: getShellConfig().remoteConfig.sportsOffer.useSimplifiedTournamentName
                    ? undefined
                    : { [ExpandedEventInUrl.tournamentId]: tournamentId.toString() },
            });
        }

        function onTournamentClick(tournamentId: number) {
            pushRoute(getTournamentRoute(tournamentId).location);
        }

        function getTournamentHref(tournamentId: number): string {
            return getTournamentRoute(tournamentId).href;
        }

        return {
            categoryFlagName: computed(() => `${getFlagByCategory(props.categoryWithCompetitions.categoryId)}.svg`),
            toggleIsExpanded,
            onTournamentClick,
            getTournamentHref,
        };
    },
    components: {
        SdsIcon,
        SdsDividerLine,
        SdsFlag,
    },
});
